import * as React from 'react'
import { useState } from 'react'
import {
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  makeStyles,
} from '@material-ui/core'
import { useTranslate } from 'react-admin'
import ButtonWithLoader from '../ui/ButtonWithLoader/ButtonWithLoader'
import consentPopupStyles from '../ConsentPopup/consentPopup.styles'
import TERMS_AND_PRIVACY_URLS from '../../utils/constants/termsAndPrivacyUrls'

// Shown after SSO has identified a new user but before the backend persists
// them. Submitting calls /v1/auth/sso/complete; cancelling drops the challenge
// and no user row was ever created.
const SsoConsentDialog = ({ open, profile, tos, submitting, onAccept, onCancel }) => {
  const translate = useTranslate()
  const useStyles = makeStyles(consentPopupStyles)
  const classes = useStyles()

  const [termsAccepted, setTermsAccepted] = useState(false)
  const [marketing, setMarketing] = useState(false)
  const [dataSharing, setDataSharing] = useState(false)

  if (!open || !tos) return null

  const greetingName = profile?.firstName ? `, ${profile.firstName}` : ''

  return (
    <Dialog open={open} disableScrollLock fullWidth maxWidth='sm' disableEscapeKeyDown>
      <DialogTitle classes={{ root: classes.dialogTitleRoot }}>
        <span className={classes.title}>Almost there{greetingName}!</span>
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContentRoot }}>
        <div className={classes.subtitle}>
          Please review our terms before we create your account.
        </div>

        <div className={classes.tosScroll}>{tos.body}</div>

        <div className={classes.sectionHeader}>{translate('ra.consentPopup.required')}</div>
        <div className={classes.checkboxRow}>
          <Checkbox
            checked={termsAccepted}
            onChange={(e) => setTermsAccepted(e.target.checked)}
            color='primary'
            size='small'
            style={{ padding: 0, marginTop: 2 }}
          />
          <div className={classes.checkboxText}>
            <span className={classes.requiredStar}>* </span>
            {translate('ra.consentPopup.acceptTermsPrefix')}{' '}
            <a
              style={{ color: '#E0726E' }}
              href={TERMS_AND_PRIVACY_URLS.TERMS_OF_USE}
              target='_blank'
              rel='noopener noreferrer'
            >
              {translate('ra.consentPopup.termsOfUse')}
            </a>{' '}
            {translate('ra.consentPopup.and')}{' '}
            <a
              style={{ color: '#E0726E' }}
              href={TERMS_AND_PRIVACY_URLS.PRIVACY_POLICY}
              target='_blank'
              rel='noopener noreferrer'
            >
              {translate('ra.consentPopup.privacyPolicy')}
            </a>
            .
          </div>
        </div>

        <div className={classes.sectionHeader}>{translate('ra.consentPopup.optional')}</div>
        <div className={classes.checkboxRow}>
          <Checkbox
            checked={marketing}
            onChange={(e) => setMarketing(e.target.checked)}
            color='primary'
            size='small'
            style={{ padding: 0, marginTop: 2 }}
          />
          <div className={classes.checkboxText}>
            {translate('ra.consentPopup.marketingConsent')}
          </div>
        </div>
        <div className={classes.checkboxRow}>
          <Checkbox
            checked={dataSharing}
            onChange={(e) => setDataSharing(e.target.checked)}
            color='primary'
            size='small'
            style={{ padding: 0, marginTop: 2 }}
          />
          <div className={classes.checkboxText}>
            {translate('ra.consentPopup.dataSharingConsent')}
          </div>
        </div>

        <div className={classes.buttonWrapper} style={{ gap: 8 }}>
          <ButtonWithLoader
            type='button'
            label='Cancel'
            disabled={submitting}
            onClick={onCancel}
            style={{ backgroundColor: '#aaa' }}
          />
          <ButtonWithLoader
            type='button'
            label={translate('ra.consentPopup.save')}
            disabled={!termsAccepted}
            loading={submitting}
            onClick={() =>
              onAccept({
                marketingConsent: marketing,
                dataSharingConsent: dataSharing,
              })
            }
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default SsoConsentDialog
